import styled from "styled-components";

export const ModalBody = styled.div`
  text-align: center;
`;

export const Icone = styled.div`
  margin: auto;
  font-size: 30px;

  svg {
    background-color: #fff5eb;
    color: #fe8f14;
    border-radius: 10px;
    padding: 4px;
  }
`;
